export default "__VITE_ASSET__D0gaPAyA__"